<template>
  <div class="carousel-container">
    <div class="carousel-wrapper" ref="carouselWrapper">
      <div class="carousel-item" v-for="(item, index) in abilityData" :key="index">
        <div class="cover">
          <video
            style="width: 100%"
            :src="item.url"
            autoplay
            loop
            playsinline
            muted
            preload="none"
          ></video>
          <div class="overlay">
            <p class="over_title">{{ item.title }}</p>
            <p class="over_msg">{{ item.msg }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <div @click="moveLeft()">
        <img
          @mouseenter="leftHover()"
          @mouseleave="removeHover()"
          class="arrow-icon-left disabled"
          src="../assets/YuanAI/right.webp"
        />
      </div>
      <div @click="moveRight()">
        <img
          @mouseenter="rightHover()"
          @mouseleave="removeHover()"
          class="arrow-icon-right"
          src="../assets/YuanAI/left.webp"
        />
      </div>
    </div>
  </div>
</template>

<script>
import y1Video from "@/assets/YuanAI/y1.mp4";
import y2Video from "@/assets/YuanAI/y2.mp4";
import y3Video from "@/assets/YuanAI/y3.mp4";
import y4Video from "@/assets/YuanAI/y4.mp4";
export default {
  name: "carousel",
  data() {
    return {
      abilityData: [
        {
          url: y1Video,
          title: "趣味交互",
          msg:
            "融合体感游戏与脑筋急转弯等元素，打破传统互动局限，深度吸引用户沉浸参与，有效延长用户停留时间。",
        },
        {
          url: y2Video,
          title: "AI智能问答",
          msg:
            "快速理解用户问题，依托强大的 AI 算法与丰富知识储备，瞬间给出清晰、准确的回答，实现高效智能的人机交互对话体验。",
        },
        {
          url: y3Video,
          title: "广告",
          msg:
            "企业上传专属的广告图片或视频，智能数字人推介广告，牢牢吸引用户目光，激发其深入了解的兴趣，巧妙引流转化，助力企业吸引用户关注并促进到店消费。",
        },
        {
          url: y4Video,
          title: "主动打招呼",
          msg:
            "借助摄像头精准识别会员身份，数字人即刻主动热情问好打招呼，有效增强会员归属感与尊崇体验，深度提升品牌亲和力与客户粘性。",
        },
      ],
      totalOffset: 0,
      singleMove: 608,
      screenWidth: 0,
      minusFloat: 0,
      touchStartX: 0,
      touchEndX: 0,
      isMoving: false, // 防止快速滑动多次触发
    };
  },
  methods: {
    moveLeft() {
      if (this.totalOffset < 0) {
        if (this.totalOffset + this.singleMove >= 0) {
          //每一步默认移动singleMove，但是到达边界地点不用遵守，而是保证边界顶格
          this.totalOffset = 0;
          let btn = this.$el.querySelector(".arrow-icon-left");
          btn.classList.add("disabled");
        } else {
          //3496是轮播图的整个宽度，包含左右240px的空格
          if (this.totalOffset == this.screenWidth - this.minusFloat) {
            let btn = this.$el.querySelector(".arrow-icon-right");
            btn.classList.remove("disabled");
          }
          this.totalOffset += this.singleMove;
        }
        this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`;
      }
    },
    moveRight() {
      if (this.totalOffset > this.screenWidth - this.minusFloat) {
        if (this.totalOffset - this.singleMove <= this.screenWidth - this.minusFloat) {
          //已经移到最后一步，保证边界顶格
          this.totalOffset = this.screenWidth - this.minusFloat;
          let btn = this.$el.querySelector(".arrow-icon-right"); //修改按钮属性（禁用）
          btn.classList.add("disabled");
        } else {
          if (this.totalOffset == 0) {
            let btn = this.$el.querySelector(".arrow-icon-left");
            btn.classList.remove("disabled");
          }
          this.totalOffset -= this.singleMove;
        }
        this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`;
      }
    },
    moveLeft() {
      if (this.totalOffset < 0) {
        if (this.totalOffset + this.singleMove >= 0) {
          //每一步默认移动singleMove，但是到达边界地点不用遵守，而是保证边界顶格
          this.totalOffset = 0;
          let btn = this.$el.querySelector(".arrow-icon-left");
          btn.classList.add("disabled");
        } else {
          //3496是轮播图的整个宽度，包含左右240px的空格
          if (this.totalOffset == this.screenWidth - this.minusFloat) {
            let btn = this.$el.querySelector(".arrow-icon-right");
            btn.classList.remove("disabled");
          }
          this.totalOffset += this.singleMove;
        }
        this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`;
      }
    },
    moveRight() {
      if (this.totalOffset > this.screenWidth - this.minusFloat) {
        if (this.totalOffset - this.singleMove <= this.screenWidth - this.minusFloat) {
          //已经移到最后一步，保证边界顶格
          this.totalOffset = this.screenWidth - this.minusFloat;
          let btn = this.$el.querySelector(".arrow-icon-right"); //修改按钮属性（禁用）
          btn.classList.add("disabled");
        } else {
          if (this.totalOffset == 0) {
            let btn = this.$el.querySelector(".arrow-icon-left");
            btn.classList.remove("disabled");
          }
          this.totalOffset -= this.singleMove;
        }
        this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`;
      }
    },
    removeHover() {
      let btn = this.$el.querySelector(".hover");
      if (btn) {
        btn.classList.remove("hover");
      }
    },
    leftHover() {
      if (this.totalOffset < 0) {
        let btn = this.$el.querySelector(".arrow-icon-left");
        btn.classList.add("hover");
      }
    },
    rightHover() {
      if (this.totalOffset > -1680) {
        let btn = this.$el.querySelector(".arrow-icon-right");
        btn.classList.add("hover");
      }
    },
    moveLeft() {
      if (this.totalOffset < 0 && !this.isMoving) {
        this.isMoving = true;
        if (this.totalOffset + this.singleMove >= 0) {
          this.totalOffset = 0;
          this.disableButton(".arrow-icon-left");
        } else {
          this.enableButton(".arrow-icon-right");
          this.totalOffset += this.singleMove;
        }
        this.updateTransform();
        setTimeout(() => (this.isMoving = false), 500);
      }
    },
    moveRight() {
      if (this.totalOffset > this.screenWidth - this.minusFloat && !this.isMoving) {
        this.isMoving = true;
        if (this.totalOffset - this.singleMove <= this.screenWidth - this.minusFloat) {
          this.totalOffset = this.screenWidth - this.minusFloat;
          this.disableButton(".arrow-icon-right");
        } else {
          this.enableButton(".arrow-icon-left");
          this.totalOffset -= this.singleMove;
        }
        this.updateTransform();
        setTimeout(() => (this.isMoving = false), 500);
      }
    },
    handleTouchStart(event) {
      this.touchStartX = event.touches[0].clientX;
    },
    handleTouchMove(event) {
      this.touchEndX = event.touches[0].clientX;
    },
    handleTouchEnd() {
      const distance = this.touchEndX - this.touchStartX;
      if (distance > 50) {
        this.moveLeft();
      } else if (distance < -50) {
        this.moveRight();
      }
    },
    updateTransform() {
      this.$refs.carouselWrapper.style.transform = `translateX(${this.totalOffset}px)`;
    },
    disableButton(selector) {
      const btn = this.$el.querySelector(selector);
      btn.classList.add("disabled");
    },
    enableButton(selector) {
      const btn = this.$el.querySelector(selector);
      btn.classList.remove("disabled");
    },
  },
  mounted() {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth < 1496) {
      this.minusFloat = 1496;
      this.singleMove = 380;
    } else {
      this.minusFloat = 3496;
      this.singleMove = 680;
    }

    const wrapper = this.$refs.carouselWrapper;
    wrapper.addEventListener("touchstart", this.handleTouchStart);
    wrapper.addEventListener("touchmove", this.handleTouchMove);
    wrapper.addEventListener("touchend", this.handleTouchEnd);
  },
};
</script>

<style lang="scss" scoped>
.carousel-container {
  width: 100vw;
  //   height: 100vh;
  overflow: hidden;
  padding-bottom: 50px;
  .carousel-wrapper {
    display: flex;
    width: 3496px;
    transition: transform 0.5s ease;
    will-change: transform;
    padding: 0px 80px; //控制左右余量
    margin: 0;
    //margin-top: 140px;
    overflow: hidden;

    .carousel-item {
      width: 370px;
      height: 620px;
      margin-right: 24px;
      position: relative;
      z-index: 1;
      overflow: hidden;
      border-radius: 8px;

      &:last-of-type {
        margin: 0;
      }
      .overlay {
        padding: 5%;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30%;
        background: rgba(0, 0, 0, 0.5); /* 半透明黑色蒙版 */
        opacity: 0;
        transition: opacity 0.3s ease;
        z-index: 4;
        .over_title {
          color: #ffffff;
          font-size: 1.5rem;
        }
        .over_msg {
          width: 90%;
          color: #ffffff;
          font-size: 1rem;
        }
      }

      &:hover .overlay {
        opacity: 1; /* 鼠标悬停时显示蒙版 */
      }
      .background-img {
        position: absolute;
        width: 280px;
        height: 420px;
        z-index: 2;
        transition: transform 0.5s ease;
        object-fit: cover;
        object-position: center;
      }
      .cover {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #000000b3;
        z-index: 3;
        position: absolute;
        bottom: 0%;
        backdrop-filter: blur(3px);
        // padding: 23px 32px;
        color: #ffffff;

        .title {
          height: 28px;
          font-weight: 500;
          font-size: 22px;
          line-height: 28px;
          margin-top: 1px;
          margin-bottom: 4px;
        }
        .subtitle {
          height: 28px;
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;
        }
        .content {
          height: 66px;
          opacity: 0.85;
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          margin-top: 10px;
        }
      }

      &:hover {
        .background-img {
          transform: scale(1.3);
        }
      }
    }
  }
  .btn-box {
    margin-left: 45%;
    display: flex;
    justify-content: center;
    margin-top: 64px;
    .arrow-icon-left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      opacity: 0.85;
      border-radius: 50%;
      background-color: #434343;
      margin-right: 40px;
    }
    .arrow-icon-right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 32px;
      height: 32px;
      opacity: 0.85;
      border-radius: 50%;
      background-color: #434343;
    }
    .disabled {
      opacity: 0.4;
    }
    .hover {
      cursor: pointer;
      opacity: 1;
    }
  }
}
@media (max-width: 768px) {
  .btn-box {
    margin-left: 55% !important;
    display: flex;
    justify-content: center;
    margin-top: 22px !important;
    margin-bottom: 12px !important;
    .arrow-icon-left {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px !important;
      height: 22px !important;
      opacity: 0.85;
      border-radius: 50%;
      background-color: #434343;
      margin-right: 10px !important;
    }
    .arrow-icon-right {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 22px !important;
      height: 22px !important;
      opacity: 0.85;
      border-radius: 50%;
      background-color: #434343;
    }
    .disabled {
      opacity: 0.4;
    }
    .hover {
      cursor: pointer;
      opacity: 1;
    }
  }
  .carousel-container {
    width: 100vw;
    //   height: 100vh;
    overflow: hidden;
    padding-bottom: 0px;
    .carousel-wrapper {
      display: flex;
      width: 1496px !important;
      transition: transform 0.5s ease;
      will-change: transform;
      padding: 0px 15px !important; //控制左右余量
      margin: 0;
      //margin-top: 40px !important;
      overflow: hidden;

      .carousel-item {
        width: 110px;
        height: 180px;
        margin-right: 14px;
        position: relative;
        z-index: 1;
        overflow: hidden;
        border-radius: 8px;
        &:last-of-type {
          margin: 0;
        }

        .background-img {
          position: absolute;
          width: 280px;
          height: 420px;
          z-index: 2;
          transition: transform 0.5s ease;
          object-fit: cover;
          object-position: center;
        }
        .cover {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #000000b3;
          z-index: 3;
          position: absolute;
          bottom: 0%;
          backdrop-filter: blur(3px);
          // padding: 23px 32px;
          color: #ffffff;

          .title {
            height: 28px;
            font-weight: 500;
            font-size: 22px;
            line-height: 28px;
            margin-top: 1px;
            margin-bottom: 4px;
          }
          .subtitle {
            height: 28px;
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
          }
          .content {
            height: 66px;
            opacity: 0.85;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-top: 10px;
          }
        }

        &:hover {
          .background-img {
            transform: scale(1.3);
          }
        }
      }
    }
  }
}
</style>
